import { render, staticRenderFns } from "./LostAndFound.vue?vue&type=template&id=9bbb01f6&scoped=true"
import script from "./LostAndFound.vue?vue&type=script&lang=js"
export * from "./LostAndFound.vue?vue&type=script&lang=js"
import style0 from "./LostAndFound.vue?vue&type=style&index=0&id=9bbb01f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbb01f6",
  null
  
)

export default component.exports